type UserProof = string;

type TaskStatus = "pending" | "completed" | "in-progress";

export type ProjectManagement = {
  id: number;
  entity_id: string;
  employee_id: string;
  created_at: string;
  updated_at: string;
  sub_project: string;
  sub_project_id: number;
  team_id: number;
  sub_team_id: number;
  project_id: number;
  description: string;
  hours_worked: number;
  employee_name: string;
  team: string;
  sub_team: string;
  project: string;
};

export interface IUpdatePostBody {
  entity_id: string;
  employee_id: string;
  date: string;
  project_id: number;
  team_id: number;
  sub_team_id: number;
  sub_project_id: number;
  hours_worked: number;
  customer_id: number;
  task_id: number;
  sub_updates: ISubUpdate[];
  span_details?: ISpanDetail[];
}

export interface ISubUpdate {
  tag_id: number[];
  description: string;
  hours_worked: number;
  session: string;
  individual_goal_id?: number;
  skills: string[];
}

export interface ISpanDetail {
  field: string;
  start_time: string;
  end_time: string;
  span: number;
}

export type IUpdate = {
  id: number;
  entity_id: string;
  employee_id: string;
  update_date: string;
  team_id: number;
  sub_team_id: number;
  project_id: number;
  sub_project_id: number;
  customer_id: number;
  customer_name: string;
  hours_worked: number;
  duration: string;
  employee_name: string;
  employee_code: string;
  team: string;
  sub_team: string;
  project: string;
  sub_project: string;
  created_at: string;
  updated_at: string;
  sub_updates: ISubUpdate[];
  task_id: number;
  task_title: string;
};

export type ISubUpdateGet = {
  id: number;
  entity_id: string;
  daily_update_id: number;
  description: string;
  session: string;
  hours_worked: number;
  duration: string;
  tag_id: number[];
  tags: string[];
  tag_list: ITagList[];
  individual_goal_id: number;
  individual_goal_title: string;
  sub_team_goal_id: number;
  sub_team_goal_title: string;
  team_goal_id: number;
  team_goal_title: string;
  company_goal_id: number;
  company_goal_title: string;
  created_at: string;
  updated_at: string;
  skills: string[];
};

export type ITagList = {
  name: string;
  id: number;
};

export enum IProjectManagementActionTypes {
  FETCH_DAILY_UPDATES_LIST_REQUEST = "FETCH_DAILY_UPDATES_LIST_REQUEST",
  FETCH_DAILY_UPDATES_LIST_SUCCESS = "FETCH_DAILY_UPDATES_LIST_SUCCESS",
  FETCH_DAILY_UPDATES_LIST_FAILURE = "FETCH_DAILY_UPDATES_LIST_FAILURE",

  FETCH_CUSTOMER_WISE_WORK_HOURS_REQUEST = "FETCH_CUSTOMER_WISE_WORK_HOURS_REQUEST",
  FETCH_CUSTOMER_WISE_WORK_HOURS_SUCCESS = "FETCH_CUSTOMER_WISE_WORK_HOURS_SUCCESS",
  FETCH_CUSTOMER_WISE_WORK_HOURS_FAILURE = "FETCH_CUSTOMER_WISE_WORK_HOURS_FAILURE",

  FETCH_PROJECT_WISE_WORK_HOURS_REQUEST = "FETCH_PROJECT_WISE_WORK_HOURS_REQUEST",
  FETCH_PROJECT_WISE_WORK_HOURS_SUCCESS = "FETCH_PROJECT_WISE_WORK_HOURS_SUCCESS",
  FETCH_PROJECT_WISE_WORK_HOURS_FAILURE = "FETCH_PROJECT_WISE_WORK_HOURS_FAILURE",

  FETCH_TEAM_WISE_WORK_HOURS_REQUEST = "FETCH_TEAM_WISE_WORK_HOURS_REQUEST",
  FETCH_TEAM_WISE_WORK_HOURS_SUCCESS = "FETCH_TEAM_WISE_WORK_HOURS_SUCCESS",
  FETCH_TEAM_WISE_WORK_HOURS_FAILURE = "FETCH_TEAM_WISE_WORK_HOURS_FAILURE",

  FETCH_CUSTOMER_WORK_ANALYSIS_REQUEST = "FETCH_CUSTOMER_WORK_ANALYSIS_REQUEST",
  FETCH_CUSTOMER_WORK_ANALYSIS_SUCCESS = "FETCH_CUSTOMER_WORK_ANALYSIS_SUCCESS",
  FETCH_CUSTOMER_WORK_ANALYSIS_ERROR = "FETCH_CUSTOMER_WORK_ANALYSIS_ERROR",

  FETCH_PROJECT_WORK_ANALYSIS_REQUEST = "FETCH_PROJECT_WORK_ANALYSIS_REQUEST",
  FETCH_PROJECT_WORK_ANALYSIS_SUCCESS = "FETCH_PROJECT_WORK_ANALYSIS_SUCCESS",
  FETCH_PROJECT_WORK_ANALYSIS_ERROR = "FETCH_PROJECT_WORK_ANALYSIS_ERROR",

  FETCH_TEAM_WORK_ANALYSIS_REQUEST = "FETCH_TEAM_WORK_ANALYSIS_REQUEST",
  FETCH_TEAM_WORK_ANALYSIS_SUCCESS = "FETCH_TEAM_WORK_ANALYSIS_SUCCESS",
  FETCH_TEAM_WORK_ANALYSIS_ERROR = "FETCH_TEAM_WORK_ANALYSIS_ERROR",

  FETCH_EMPLOYEE_WORK_ANALYSIS_REQUEST = "FETCH_EMPLOYEE_WORK_ANALYSIS_REQUEST",
  FETCH_EMPLOYEE_WORK_ANALYSIS_SUCCESS = "FETCH_EMPLOYEE_WORK_ANALYSIS_SUCCESS",
  FETCH_EMPLOYEE_WORK_ANALYSIS_ERROR = "FETCH_EMPLOYEE_WORK_ANALYSIS_ERROR",

  FETCH_PENDING_UPDATES_LIST_REQUEST = "FETCH_PENDING_UPDATES_LIST_REQUEST",
  FETCH_PENDING_UPDATES_LIST_SUCCESS = "FETCH_PENDING_UPDATES_LIST_SUCCESS",

  UPDATE_DAILY_UPDATES_REQUEST = "UPDATE_DAILY_UPDATES_REQUEST",
  UPDATE_DAILY_UPDATES_SUCCESS = "UPDATE_DAILY_UPDATES_SUCCESS",
  UPDATE_DAILY_UPDATES_FAILURE = "UPDATE_DAILY_UPDATES_FAILURE",

  FECTH_SESSIONS_LIST_REQUEST = "FECTH_SESSIONS_LIST_REQUEST",
  FECTH_SESSIONS_LIST_SUCCESS = "FECTH_SESSIONS_LIST_SUCCESS",
  FECTH_SESSIONS_LIST_ERROR = "FECTH_SESSIONS_LIST_ERROR",
}

export type ITicketManagementActionCreator = {
  type: string;
  payload: any;
};

export interface IProcurementLeads {
  id: number;
  entity_id: string;
  step: string;
  leads: IProcurementLead[];
}

export interface IProcurementLead {
  lead_name: string;
  team_name: string;
  employee_id: string;
  status: string;
  status_updated_on: string;
}
